import locale from 'meta-ui/lib/locale/lang/zh-TW';
import zhHant from 'govmo-common/src/locales/zh-Hant.json';
import merge from 'lodash/merge';
import DataComponent from 'common/components/Data/locales/zh-Hant.json';
import MessagePluginComponent from 'common/plugins/message/locales/zh-Hant.json';

export default {
  ...DataComponent,
  ...MessagePluginComponent,
  ...merge(locale, {
    el: {
      transfer: {
        filterPlaceholder: '請輸入搜索內容',
      },
    },
  }),
  ...zhHant,
};
